import { Grid, TextField } from '@mui/material';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

import { OrderDatagrid } from '../components/OrderDatagrid';

export const OrderOverview = () => {
  const { t } = useTranslation();

  const [searchInput, setSearchInput] = useState<string>('');

  return (
    <Grid container style={{ height: '75vh' }}>
      <TextField
        label={t(translations.common.search())}
        variant="outlined"
        size="small"
        sx={{ margin: 1 }}
        value={searchInput}
        onChange={event => setSearchInput(event.target.value)}
      />
      <OrderDatagrid filters={{ search: searchInput.length > 0 ? searchInput : undefined }} />
    </Grid>
  );
};
